import React, { useState, useEffect, useContext } from "react";
import { Redirect, Link, useLocation } from "react-router-dom";
import { Icon, Table, notification, Modal, Select } from "antd";
import { v4 as uuidv4 } from "uuid";

import axios from "axios";
import moment from "moment";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import ModalAta from "./Drawer/Ata";
import ModalAtaSat from "../../../GerirDetalheTurma/Aproveitamento/Relatorios/Drawer/AtaSAT";
import ModalEmissao from "./Drawer/EmissaoAtaClasse";

import Acessos from "../../../Geral/Acessos/Acessos";

import { GlobalContext } from "../../../app/providers/GlobalState";

import ModalGerarDocumento from "../../../shared/components/Modals/GerarDocumentoMultisseriado";

import { Teacher, Eye } from "iconsax-react";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};
const { Option } = Select;

const Relatorios = ({ match }) => {
    const [isSat, setIsSat] = useState(false);
    const [estruturaId, setEstruturaId] = useState(undefined);
    const [alunos, setAlunos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [isEnsinoInfantil, setIsEnsinoInfantil] = useState(0);
    const [loadingText, setLoadingText] = useState("");
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [ataVisible, setAtaVisible] = useState(false);
    const [ataClasseVisible, setAtaClasseVisible] = useState(false);
    const [ataIndividualEmMassaVisible, setAtaIndividualEmMassaVisible] = useState(false);
    const [ataIndividualAgrupEmMassaVisible, setAtaIndividualAgrupEmMassaVisible] = useState(false);
    const [fichaDescritivaEmMassaVisible, setFichaDescritivaEmMassaVisible] = useState(false);
    const [boletimEscolarEmMassaVisible, setBoletimEscolarEmMassaVisible] = useState(false);

    const [ataAgrupVisible, setAtaAgrupVisible] = useState(false);
    const [visualizarExcel, setVisualizarExcel] = useState(false);
    const [individualInfo, setIndividualInfo] = useState({
        visible: false,
        code: ""
    });

    const [boletimEscolarInfo, setBoletimEscolarInfo] = useState({
        visible: false,
        code: ""
    });

    const [individualInfoAgrup, setIndividualInfoAgrup] = useState({
        visible: false,
        code: ""
    });
    const [descritivaInfo, setDescritivaInfo] = useState({
        visible: false,
        code: ""
    });
    const [existeFicha, setExisteFicha] = useState(false);
    const [existeAtaClasse, setExisteAtaClasse] = useState(false);

    const [progresso, setProgresso] = useState([]);
    const [turmasMultisseriado, setTurmasMultisseriado] = useState();
    const [turmasProgresso, setTurmasProgresso] = useState();
    const [selectedOptions, setSelectedOptions] = useState([]);

    const context = useContext(GlobalContext);

    const location = useLocation();

    const turmas = () => {
        axios({
            method: "get",
            url: "/api/gerir-turma/carregar-header-info",
            params: {
                cursoid: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const dados = response.data.multisseriados.map(dado => ({
                    ...dado,
                    value: dado.id,
                    label: dado.nome
                }));

                setTurmasMultisseriado(dados);

                // Define a opção inicial selecionada com base no localStorage
                const codigoCurso = Number(localStorage.getItem("codigo_curso"));
                const inicialSelecionada = dados.filter(x => x.value === codigoCurso).map(x => x.value);
                setSelectedOptions(inicialSelecionada);
                localStorage.setItem("selectedOptions", JSON.stringify(inicialSelecionada));
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    // setRedirectLink("/login");
                    // setRedirect(true);
                }
            });
    };

    const listar = estruturaId => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/aproveitamento/listar-alunos",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                //let alunos = [];

                response.data.map(item => {
                    alunos.push({
                        key: item.id,
                        aluno: `${item.codigo} - ${item.nome}`,
                        opcoes: (
                            <div className="documentos-opcoes" style={{ display: "flex", gap: 10 }}>
                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className="botao-icon-detalhe"
                                    onClick={() =>
                                        setIndividualInfoAgrup({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Icon type="switcher" />
                                </Link>
                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className={`botao-icon-botao-avaliacoes-visualizar ${!estruturaId ? "botao-disabled" : ""}`}
                                    disabled={!estruturaId}
                                    onClick={() =>
                                        setIndividualInfo({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualizar
                                </Link>
                            </div>
                        )
                    });
                });

                setLoading(false);
                setAlunos(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    };

    const validarSat = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/listar-estruturas-avaliacao-turma",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setIsSat(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarExistenciaFichaDescritiva = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-existencia-ficha-descritiva",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setExisteFicha(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarExistenciaAtaClasse = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-existencia-ata-classe",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setExisteAtaClasse(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarFichaEnsinoInfantil = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-ficha-ensino-infantil",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setIsEnsinoInfantil(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const carregarFichaIndividualAgrupamento = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ficha-anual-fundamental-agrupamento",
            params: {
                estruturaId: estruturaId,
                cursoId: localStorage.getItem("codigo_curso"),
                code,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarBoletimEscolar = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/boletim-escolar",
            params: {
                estruturaId: estruturaId,
                cursoId: localStorage.getItem("codigo_curso"),
                code,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarFichaAtaClasse = (periodoId, dataEmissao, horaEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ata-classes",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                periodoId,
                dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                horaEmissao: horaEmissao.format("HH:mm")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarFichaIndividualAgrupamentoEmMassa = async dataEmissao => {
        const uniqueFolderPath = uuidv4();

        setVisibleExportar(true);
        setBtnDescarregar(true);

        setTurmasProgresso(() => {
            const turmasSelecionadas = turmasMultisseriado
                .filter(turma => selectedOptions.includes(turma.id))
                .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso
            return turmasSelecionadas;
        });

        const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

        try {
            for (let i = 0; i < selectedOptions.length; i++) {
                const cursoId = selectedOptions[i];

                await axios
                    .post("/api/pdf/ficha-fundamental-multisseriado-massa", {
                        cursoId: [cursoId], // Processa uma turma por vez
                        dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                        uniqueFolderPath: uniqueFolderPath
                    })
                    .then(response => {
                        setTurmasProgresso(prevTurmas => {
                            const newTurmas = [...prevTurmas];
                            const index = newTurmas.findIndex(turma => turma.id === cursoId);
                            if (index !== -1) {
                                newTurmas[index].concluido = true;
                            }
                            return newTurmas;
                        });
                    });
            }

            await axios
                .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                    params: {
                        caminho: uniqueFolderPath
                    }
                })
                .then(response => {
                    setBtnDescarregar(false);
                    setFicheiroExportar(response.data.fileUrl);
                });
        } catch (error) {
            // Em caso de erro
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
            setVisibleExportar(false);
        }
    };

    const carregarFichaDescritivaAgrupamentoEmMassa = async dataEmissao => {
        const uniqueFolderPath = uuidv4();

        setVisibleExportar(true);
        setBtnDescarregar(true);

        setTurmasProgresso(() => {
            const turmasSelecionadas = turmasMultisseriado
                .filter(turma => selectedOptions.includes(turma.id))
                .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso
            return turmasSelecionadas;
        });

        const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

        try {
            for (let i = 0; i < selectedOptions.length; i++) {
                const cursoId = selectedOptions[i];

                await axios
                    .post("/api/pdf/ficha-descritiva-multisseriado-massa", {
                        cursoId: [cursoId], // Processa uma turma por vez
                        dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                        uniqueFolderPath: uniqueFolderPath
                    })
                    .then(response => {
                        setTurmasProgresso(prevTurmas => {
                            const newTurmas = [...prevTurmas];
                            const index = newTurmas.findIndex(turma => turma.id === cursoId);
                            if (index !== -1) {
                                newTurmas[index].concluido = true;
                            }
                            return newTurmas;
                        });
                    });
            }

            await axios
                .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                    params: {
                        caminho: uniqueFolderPath
                    }
                })
                .then(response => {
                    setBtnDescarregar(false);
                    setFicheiroExportar(response.data.fileUrl);
                });
        } catch (error) {
            // Em caso de erro
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
            setVisibleExportar(false);
        }
    };

    const carregarBoletimEscolarAgrupamentoEmMassa = async dataEmissao => {
        const uniqueFolderPath = uuidv4();

        setVisibleExportar(true);
        setBtnDescarregar(true);

        setTurmasProgresso(() => {
            const turmasSelecionadas = turmasMultisseriado
                .filter(turma => selectedOptions.includes(turma.id))
                .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso
            return turmasSelecionadas;
        });

        const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

        try {
            for (let i = 0; i < selectedOptions.length; i++) {
                const cursoId = selectedOptions[i];

                await axios
                    .post("/api/pdf/boletim-escolar-multisseriado-massa", {
                        cursoId: [cursoId], // Processa uma turma por vez
                        dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                        uniqueFolderPath: uniqueFolderPath
                    })
                    .then(response => {
                        setTurmasProgresso(prevTurmas => {
                            const newTurmas = [...prevTurmas];
                            const index = newTurmas.findIndex(turma => turma.id === cursoId);
                            if (index !== -1) {
                                newTurmas[index].concluido = true;
                            }
                            return newTurmas;
                        });
                    });
            }

            await axios
                .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                    params: {
                        caminho: uniqueFolderPath
                    }
                })
                .then(response => {
                    setBtnDescarregar(false);
                    setFicheiroExportar(response.data.fileUrl);
                });
        } catch (error) {
            // Em caso de erro
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
            setVisibleExportar(false);
        }
    };

    const carregarFichaDescritiva = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ficha-descritiva",
            params: {
                code,
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const ExportarExcel = async () => {
        const uniqueFolderPath = uuidv4();
        setVisibleExportar(true);
        setBtnDescarregar(true);
        setTurmasProgresso(() => {
            const turmasSelecionadas = turmasMultisseriado
                .filter(turma => selectedOptions.includes(turma.id))
                .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso
            return turmasSelecionadas;
        });

        const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

        try {
            for (let i = 0; i < selectedOptions.length; i++) {
                const cursoId = selectedOptions[i];

                await axios
                    .get("/api/excel/exportar-notas-excel-multisseriado", {
                        params: {
                            turmaId: cursoId, // Processa uma turma por vez
                            uniqueFolderPath: uniqueFolderPath
                        }
                    })
                    .then(response => {
                        setTurmasProgresso(prevTurmas => {
                            const newTurmas = [...prevTurmas];
                            const index = newTurmas.findIndex(turma => turma.id === cursoId);
                            if (index !== -1) {
                                newTurmas[index].concluido = true;
                            }
                            return newTurmas;
                        });
                    });
            }

            await axios
                .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                    params: {
                        caminho: uniqueFolderPath
                    }
                })
                .then(response => {
                    setBtnDescarregar(false);
                    setFicheiroExportar(response.data.fileUrl);
                });
        } catch (error) {
            // Em caso de erro
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
            setVisibleExportar(false);
        }
    };

    const carregarAtaAgrupamentoResultados = async dataEmissao => {
        if (localStorage.getItem("entidade_id") == 33) {
            setLoadingText("A carregar documento...");
            setVisibleLoading(true);

            axios({
                method: "get",
                url: "/api/pdf/ata-notas-agrupamentos",
                params: {
                    cursoId: localStorage.getItem("codigo_curso"),
                    dataEmissao: dataEmissao.format("YYYY-MM-DD")
                }
            })
                .then(response => {
                    const { url, fileName } = response.data;

                    setDocs([{ uri: url, fileName }]);

                    setVisibleLoading(false);
                    setModalVisible(true);
                })
                .catch(() => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                    setVisibleLoading(false);
                });
        } else {
            const uniqueFolderPath = uuidv4();

            setVisibleExportar(true);
            setBtnDescarregar(true);

            setTurmasProgresso(() => {
                const turmasSelecionadas = turmasMultisseriado
                    .filter(turma => selectedOptions.includes(turma.id))
                    .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso
                return turmasSelecionadas;
            });

            const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

            try {
                for (let i = 0; i < selectedOptions.length; i++) {
                    const cursoId = selectedOptions[i];

                    await axios
                        .get("/api/pdf/ata-notas-agrupamentos-multisseriado", {
                            params: {
                                curso: cursoId, // Processa uma turma por vez
                                dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                                uniqueFolderPath: uniqueFolderPath
                            }
                        })
                        .then(response => {
                            setTurmasProgresso(prevTurmas => {
                                const newTurmas = [...prevTurmas];
                                const index = newTurmas.findIndex(turma => turma.id === cursoId);
                                if (index !== -1) {
                                    newTurmas[index].concluido = true;
                                }
                                return newTurmas;
                            });
                        });
                }

                await axios
                    .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                        params: {
                            caminho: uniqueFolderPath
                        }
                    })
                    .then(response => {
                        setBtnDescarregar(false);
                        setFicheiroExportar(response.data.fileUrl);
                    });
            } catch (error) {
                // Em caso de erro
                openNotificationWithIcon("error", "Erro", error.response.data);
                setVisibleExportar(false);
            }
        }
    };

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    useEffect(() => {
        listar();
        validarSat();
        validarExistenciaFichaDescritiva();
        validarExistenciaAtaClasse();
        validarFichaEnsinoInfantil();
        turmas();
    }, [location.pathname]);

    const columns = [
        {
            title: "Aluno",
            dataIndex: "aluno"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    const alunosTemp = alunos.map(item => {
        return {
            key: item.id,
            aluno: `${item.codigo} - ${item.nome}`,
            opcoes: (
                <div className="documentos-opcoes" style={{ display: "flex", gap: 10 }}>
                    {isEnsinoInfantil !== 236 && (
                        <>
                            <Link
                                to="#"
                                title="Visualizar"
                                className="botao-avaliacoes-ficha-ind"
                                onClick={() =>
                                    setIndividualInfoAgrup({
                                        visible: true,
                                        code: item.code
                                    })
                                }
                            >
                                <Eye size="24" color="#FFFFFF" />
                                Ficha individual
                            </Link>

                            <Link
                                to="#"
                                title="Visualizar"
                                className="botao-boletim-escolar"
                                onClick={() =>
                                    setBoletimEscolarInfo({
                                        visible: true,
                                        code: item.code
                                    })
                                }
                            >
                                <Eye size="24" color="#FFFFFF" />
                                Boletim Escolar
                            </Link>
                        </>
                    )}
                    {(context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha && (
                        <Link
                            to="#"
                            title="Visualizar"
                            className="botao-avaliacoes-ficha-des"
                            onClick={() =>
                                setDescritivaInfo({
                                    visible: true,
                                    code: item.code
                                })
                            }
                        >
                            <Eye size="24" color="#FFFFFF" />
                            Ficha descritiva
                        </Link>
                    )}
                </div>
            )
        };
    });

    const titulo =
        (context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha
            ? "Fichas individuais & Fichas Descritivas"
            : "Fichas individuais";

    return (
        <>
            <Acessos funcionalidadeId={15} />
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="curso-resultados">
                        <div className="controlos controlos-fundo">
                            <div className="bloco-esquerda"></div>
                            <div className="bloco-direita">
                                <span style={{ fontSize: 18, fontWeight: "bold" }}>Ata de resultados finais:</span>
                                <Link to="#" className="botao-avaliacoes-excel" title="Excel" onClick={() => setVisualizarExcel(true)}>
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualização em excel
                                </Link>
                                <Link
                                    to="#"
                                    className="botao-avaliacoes-visualizar"
                                    title="Visualizar"
                                    onClick={() => setAtaAgrupVisible(true)}
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualizar
                                </Link>
                                {montarBotaoVoltar()}
                            </div>
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="controlos controlos-fundo">
                            <div className="bloco-esquerda">
                                <span style={{ fontSize: 22, fontWeight: "bold" }}>{titulo}</span>
                            </div>
                            <div className="bloco-direita" style={{ marginRight: "10px" }}>
                                {isEnsinoInfantil !== 236 && (
                                    <>
                                        <Link
                                            to="#"
                                            className="botao-avaliacoes-ficha-ind"
                                            style={{ display: "flex", gap: 10 }}
                                            title="Visualizar"
                                            onClick={() => setAtaIndividualAgrupEmMassaVisible(true)}
                                        >
                                            <Eye size="24" color="#FFFFFF" />
                                            Fichas individuais
                                        </Link>

                                        <Link
                                            to="#"
                                            className="botao-boletim-escolar"
                                            style={{ display: "flex", gap: 10 }}
                                            title="Visualizar"
                                            onClick={() => setBoletimEscolarEmMassaVisible(true)}
                                        >
                                            <Eye size="24" color="#FFFFFF" />
                                            Boletins Escolares
                                        </Link>
                                    </>
                                )}
                                {isEnsinoInfantil === 290 && existeAtaClasse && (
                                    <Link to="#" title="Visualizar" className="botao-icon-pdf" onClick={() => setAtaClasseVisible(true)}>
                                        <Icon type="eye" />
                                    </Link>
                                )}
                                {(context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha && (
                                    <Link
                                        to="#"
                                        className="botao-avaliacoes-ficha-des"
                                        style={{ display: "flex", gap: 10 }}
                                        title="Visualizar"
                                        onClick={() => setFichaDescritivaEmMassaVisible(true)}
                                    >
                                        <Eye size="24" color="#FFFFFF" />
                                        Fichas descritivas
                                    </Link>
                                )}
                            </div>
                        </div>
                        <Table
                            id="disciplinas"
                            loading={{
                                spinning: loading,
                                indicator: (
                                    <div className="loading-data-table">
                                        <div className="loading" />
                                    </div>
                                )
                            }}
                            columns={columns}
                            dataSource={alunosTemp}
                            pagination={false}
                            locale={{ emptyText: "Não existem dados!" }}
                        />
                    </div>
                </div>
            </div>
            <ModalLoading visible={visibleLoading} text={loadingText} />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
                turmasMultisseriado={turmasProgresso}
            />
            <ModalAta //GERAR ZIP COM PDFS DA FICHA INDIVIDUAL
                visible={ataIndividualAgrupEmMassaVisible}
                onClose={() => setAtaIndividualAgrupEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarFichaIndividualAgrupamentoEmMassa(dataEmissao);
                    setAtaIndividualAgrupEmMassaVisible(false);
                }}
                turmasMultisseriado={turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />

            <ModalAta //GERAR ZIP COM PDFS DO BOLETIM ESCOLAR
                visible={boletimEscolarEmMassaVisible}
                onClose={() => setBoletimEscolarEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarBoletimEscolarAgrupamentoEmMassa(dataEmissao);
                    setBoletimEscolarEmMassaVisible(false);
                }}
                turmasMultisseriado={turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />

            <ModalAta //GERAR ZIP COM PDFS DA FICHA DESCRITIVA
                visible={fichaDescritivaEmMassaVisible}
                onClose={() => setFichaDescritivaEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarFichaDescritivaAgrupamentoEmMassa(dataEmissao);
                    setFichaDescritivaEmMassaVisible(false);
                }}
                turmasMultisseriado={turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />

            <ModalAta //GERAR PDF ATA DE RESULTADOS
                visible={ataAgrupVisible}
                onClose={() => setAtaAgrupVisible(false)}
                turmas={""}
                onConfirm={dataEmissao => {
                    carregarAtaAgrupamentoResultados(dataEmissao);
                    setAtaAgrupVisible(false);
                }}
                turmasMultisseriado={localStorage.getItem("entidade_id") == 33 ? null : turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />

            {isSat ? (
                <>
                    <ModalAtaSat
                        visible={ataAgrupVisible}
                        onClose={() => setAtaAgrupVisible(false)}
                        onConfirm={(cursoId, dataEmissao) => {
                            carregarAtaAgrupamentoResultados(cursoId, dataEmissao);
                            setAtaAgrupVisible(false);
                        }}
                    />
                </>
            ) : (
                <ModalAta //GERAR PDF ATA DE RESULTADOS
                    visible={ataAgrupVisible}
                    onClose={() => setAtaAgrupVisible(false)}
                    turmas={""}
                    onConfirm={dataEmissao => {
                        carregarAtaAgrupamentoResultados(dataEmissao);
                        setAtaAgrupVisible(false);
                    }}
                    turmasMultisseriado={localStorage.getItem("entidade_id") == 33 ? null : turmasMultisseriado}
                    selectedOptionsResultados={selectedOptions}
                />
            )}

            <ModalAta //GERAR PDF ATA DE RESULTADOS
                visible={visualizarExcel}
                onClose={() => setVisualizarExcel(false)}
                turmas={""}
                onConfirm={dataEmissao => {
                    ExportarExcel();
                    setVisualizarExcel(false);
                }}
                turmasMultisseriado={turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />

            <ModalAta //GERAR PDF FICHA INDIVIDUAL
                visible={individualInfoAgrup.visible}
                onClose={() => setIndividualInfoAgrup({ ...individualInfoAgrup, visible: false })}
                onConfirm={dataEmissao => {
                    carregarFichaIndividualAgrupamento(individualInfoAgrup.code, dataEmissao);
                    setIndividualInfoAgrup({ ...individualInfoAgrup, visible: false });
                }}
                turmasMultisseriado={null}
            />
            {isEnsinoInfantil === 290 && existeAtaClasse && (
                <ModalEmissao //GERAR PDF ATA CLASSE
                    visible={ataClasseVisible}
                    onClose={() => setAtaClasseVisible(false)}
                    onConfirm={(periodo, dataEmissao, horaEmissao) => {
                        carregarFichaAtaClasse(periodo, dataEmissao, horaEmissao);
                        setAtaClasseVisible(false);
                    }}
                />
            )}

            <ModalAta //GERAR PDF FICHA BOLETIM ESCOLAR
                visible={boletimEscolarInfo.visible}
                onClose={() => setBoletimEscolarInfo({ ...boletimEscolarInfo, visible: false })}
                onConfirm={dataEmissao => {
                    carregarBoletimEscolar(boletimEscolarInfo.code, dataEmissao);
                    setBoletimEscolarInfo({ ...boletimEscolarInfo, visible: false });
                }}
            />

            <ModalAta //GERAR PDF FICHA DESCRITIVA
                visible={descritivaInfo.visible}
                onClose={() => setDescritivaInfo({ ...descritivaInfo, visible: false })}
                onConfirm={dataEmissao => {
                    carregarFichaDescritiva(descritivaInfo.code, dataEmissao);
                    setDescritivaInfo({ ...descritivaInfo, visible: false });
                }}
                turmasMultisseriado={null}
            />
        </>
    );
};
export default Relatorios;
